export type PromotionEntryExcelTemplate = {
    "NEW/EXISTING": string | null,
    PROMOTIONID: string | null,
    PROMOTIONDESC: string | null,
    PROMOTIONTYPE: string | null,
    PROMOTIONCATEGORY: string | null,
    EXCEPTIONTYPE: string | null,

    CUSTOMERID: string | null,
    CUSTOMERNAME: string | null,

    COUNTRYCODE: string | null,
    SEGMENT: string | null,
    CHANNEL: string | null,
    TIER: string | null,
    BUYINGGROUP: string | null,
    CORPORATEAFFILIATION: string | null,
    PRICEZONE: string | null,
    FREIGHTZONE: string | null,

    PRODUCTLINE: string | null,
    PRODUCTCATEGORY: string | null,

    ITEMNUMBER: string | null,
    MANUFACTURERSNUMBER: string | null,
    GTIN: string | null,
    ALLOWMULTIPLE: string | null,

    EMPLOYEERESPONSIBLEPRICING: string | null,
    JOBTYPE: string | null,
    SUPPLIERFLAG: string | null,

    PROMOTIONAMOUNT: string | null,
    UOM: string | null,
    WEIGHTTYPE: string | null,
    PROMOTIONPERCENT: string | null,

    MINIMUMVALUE: string | null,
    MINIMUMCODE: string | null,

    MAXIMUMVALUE: string | null,
    MAXIMUMCODE: string | null,

    BEGINORDERDATE: string | null,
    ENDORDERDATE: string | null,
    BEGINDELIVERYDATE: string | null,
    ENDDELIVERYDATE: string | null,

    PROMOTIONADJUSTMENT: string | null,
    CASEQUANTITY: string | null,
    SERVICELOCATION: string | null,
}

export const PromotionEntryExcelTemplate_Default = {
    "NEW/EXISTING": null,
    PROMOTIONID: "",
    PROMOTIONDESC: "",
    PROMOTIONTYPE: "",
    PROMOTIONCATEGORY: "",
    EXCEPTIONTYPE: "",

    CUSTOMERID: "",
    CUSTOMERNAME: "",

    COUNTRYCODE: "",
    SEGMENT: "",
    CHANNEL: "",
    TIER: "",
    BUYINGGROUP: "",
    CORPORATEAFFILIATION: "",
    PRICEZONE: "",
    FREIGHTZONE: "",

    PRODUCTLINE: "",
    PRODUCTCATEGORY: "",

    ITEMNUMBER: "",
    MANUFACTURERSNUMBER: "",
    GTIN: "",
    ALLOWMULTIPLE: "",

    EMPLOYEERESPONSIBLEPRICING: "",
    JOBTYPE: "",
    SUPPLIERFLAG: "",

    PROMOTIONAMOUNT: "0",
    UOM: "",
    WEIGHTTYPE: "",
    PROMOTIONPERCENT: "0",

    MINIMUMVALUE: "",
    MINIMUMCODE: "",

    MAXIMUMVALUE: "",
    MAXIMUMCODE: "",

    BEGINORDERDATE: "",
    ENDORDERDATE: "",
    BEGINDELIVERYDATE: "",
    ENDDELIVERYDATE: "",

    PROMOTIONADJUSTMENT: "",
    CASEQUANTITY: "",
    SERVICELOCATION: "",
} as PromotionEntryExcelTemplate;
